import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { assetApi, type DuplicateGroup } from '../../api/media';

export function DuplicateManagerPage() {
  const [groups, setGroups] = useState<DuplicateGroup[]>([]);

  useEffect(() => {
    void assetApi.duplicates().then(setGroups);
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/media" className="text-sm text-slate-600 hover:underline">← Library</Link>
      <h1 className="mt-4 text-2xl font-semibold">Duplicate Manager</h1>
      <ul className="mt-6 space-y-4">
        {groups.map((g) => (
          <li key={g.checksum} className="rounded-xl border bg-white p-4">
            <p className="font-mono text-xs text-slate-500">{g.checksum}</p>
            <p className="mt-1 text-sm">{g.count} duplicate{g.count === 1 ? '' : 's'}</p>
            <ul className="mt-2 space-y-1 text-sm">
              {g.assets.map((a) => (
                <li key={a.id}><Link to={`/media/assets/${a.id}`} className="hover:underline">{a.name}</Link></li>
              ))}
            </ul>
          </li>
        ))}
        {groups.length === 0 && <p className="text-slate-500">No duplicates detected.</p>}
      </ul>
    </div>
  );
}
